import AnimationTable from "#common/AnimationTabla"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import { Box, Button, Stack } from "@mui/material"
import { ChangeTitle } from "Components/menu/funciones"
import { useNavigate } from "react-router-dom"

/**
 *
 * @param {*} param0
 * @returns
 */

export default function TableWithDetails({
	title = "",
	ruta = "",
	table,
	details,
	showDetails = false,
}) {
	ChangeTitle(title)
	const navigate = useNavigate()
	return (
		<Box display="flex" width="100%" flexDirection={"column"}>
			<AnimationTable activar={!showDetails}>{table}</AnimationTable>

			<AnimationTable activar={showDetails}>
				<Box
					sx={{
						width: "100%",
						maxHeight: "91vh", // igual que el padre para evitar overflow
						overflowY: "auto", // aquí activas el scroll
						pr: 3, // opcional: padding para evitar que tape el scrollbar
					}}
				>
					<Stack spacing={2} padding={2}>
						{/*<div>
							<Button
								variant="text"
								size="small"
								onClick={() => navigate(ruta)}
								startIcon={<ArrowBackIcon />}
							>
								Regresar
							</Button>
						</div>*/}
						{details}
					</Stack>
				</Box>
			</AnimationTable>
		</Box>
	)
}
